import React from "react";
import { BsCheckCircle, BsClock } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

const appointments = [
  {
    "Appointment ID": "APP0001",
    "Patient Name": "Jhanavi",
    "Time Slot": "10:00 AM",
    Doctor: "Dr. Smith",
    "Reason for Visit": "General Checkup",
    "Visit Type": "In-person",
    "Consultation Notes": "Dr. Smith has consulted on the patient's symptoms",
    "Prescription Issued": "Yes",
    "Follow-Up Required": "No",
  },
  {
    "Appointment ID": "APP0002",
    "Patient Name": "Sanju",
    "Time Slot": "11:00 AM",
    Doctor: "Dr. Hemanth",
    "Reason for Visit": "Follow-up",
    "Visit Type": "Virtual",
    "Consultation Notes":
      "The patient has shown improvement since the last visit.",
    "Prescription Issued": "No",
    "Follow-Up Required": "Yes",
  },
  {
    "Appointment ID": "APP0003",
    "Patient Name": "Rahul",
    "Time Slot": "1:30 PM",
    Doctor: "Dr. Smith",
    "Reason for Visit": "Diagnosis",
    "Visit Type": "In-person",
    "Consultation Notes":
      "Dr. Smith is investigating symptoms of fatigue and dizziness.",
    "Prescription Issued": "Yes",
    "Follow-Up Required": "Yes",
  },
  {
    "Appointment ID": "APP0004",
    "Patient Name": "Ritish",
    "Time Slot": "3:00 PM",
    Doctor: "Dr. Santhosh",
    "Reason for Visit": "General Checkup",
    "Visit Type": "Virtual",
    "Consultation Notes": "Routine checkup conducted via virtual consultation.",
    "Prescription Issued": "No",
    "Follow-Up Required": "No",
  },
  {
    "Appointment ID": "APP0005",
    "Patient Name": "Shanthi",
    "Time Slot": "4:45 PM",
    Doctor: "Dr. Smith",
    "Reason for Visit": "Follow-up",
    "Visit Type": "In-person",
    "Consultation Notes":
      "Follow-up consultation for prior respiratory issues.",
    "Prescription Issued": "Yes",
    "Follow-Up Required": "No",
  },
  {
    "Appointment ID": "APP0006",
    "Patient Name": "shankar",
    "Time Slot": "9:00 AM",
    Doctor: "Dr. Rao",
    "Reason for Visit": "Diagnosis",
    "Visit Type": "Virtual",
    "Consultation Notes": "Initial consultation for newly reported joint pain.",
    "Prescription Issued": "No",
    "Follow-Up Required": "Yes",
  },
  {
    "Appointment ID": "APP0007",
    "Patient Name": "Chandu",
    "Time Slot": "10:15 AM",
    Doctor: "Dr. Smith",
    "Reason for Visit": "General Checkup",
    "Visit Type": "In-person",
    "Consultation Notes": "Dr. Smith conducted a comprehensive checkup.",
    "Prescription Issued": "Yes",
    "Follow-Up Required": "No",
  },
  {
    "Appointment ID": "APP0008",
    "Patient Name": "Ananth",
    "Time Slot": "2:30 PM",
    Doctor: "Dr. Amit",
    "Reason for Visit": "Follow-up",
    "Visit Type": "Virtual",
    "Consultation Notes": "Follow-up for recovery after flu symptoms.",
    "Prescription Issued": "No",
    "Follow-Up Required": "No",
  },
  {
    "Appointment ID": "APP0009",
    "Patient Name": "Teja",
    "Time Slot": "12:00 PM",
    Doctor: "Dr. Smith",
    "Reason for Visit": "Diagnosis",
    "Visit Type": "In-person",
    "Consultation Notes": "Consultation for persistent headache and nausea.",
    "Prescription Issued": "Yes",
    "Follow-Up Required": "Yes",
  },
  {
    "Appointment ID": "APP0010",
    "Patient Name": "Rishitha ",
    "Time Slot": "3:45 PM",
    Doctor: "Dr. Emily Brown",
    "Reason for Visit": "General Checkup",
    "Visit Type": "Virtual",
    "Consultation Notes":
      "Routine virtual checkup for monitoring health metrics.",
    "Prescription Issued": "No",
    "Follow-Up Required": "No",
  },
  {
    "Appointment ID": "APP0011",
    "Patient Name": "Pravallika",
    "Time Slot": "11:30 AM",
    Doctor: "Dr. Smith",
    "Reason for Visit": "Follow-up",
    "Visit Type": "In-person",
    "Consultation Notes": "Post-surgical follow-up consultation conducted.",
    "Prescription Issued": "Yes",
    "Follow-Up Required": "Yes",
  },
];

const AppointmentHistoryGrid = () => {
    const navigate = useNavigate();
  return (
    <div className="row">
      {appointments.map((appointment) => (
        <div className="col-sm-4 mb-3" key={appointment["Appointment ID"]}>
          <div
            className="card shadow-sm"
            style={{ borderRadius: "12px", border: "1px solid #ddd" }}
          >
            <div className="card-body">
              <div
                className="d-flex justify-content-between align-items-center pb-2"
                style={{
                  borderBottom: "2px dashed #6b93b0",
                  paddingBottom: "8px",
                }}
              >
                <h6
                  style={{
                    color: "grey",
                    fontWeight: "bold",
                    fontSize: "12px",
                    margin: 0,
                  }}
                >
                  {appointment["Appointment ID"]}
                </h6>
                <button className="px-2"
                  style={{
                    border: "none",
                    background: "orange",
                    color: "#fff",
                    borderRadius:'12px'
                  }}
                  onClick={() => {
                    navigate("/patient-history");
                  }}
                >
                  <p style={{fontSize:'12px'}}>View</p>
                </button>
              </div>

              <div className="mt-2 mb-3">
                <div className="d-flex justify-content-between">
                  <p className="fw-bold" style={{ fontSize: "12px" }}>
                    Patient Name
                  </p>
                  <p className="mb-0 me-3" style={{ fontSize: "12px" }}>
                    {appointment["Patient Name"]}
                  </p>
                </div>
                <div className="d-flex justify-content-between">
                  <p className="fw-bold" style={{ fontSize: "12px" }}>
                    Reason for Visit
                  </p>
                  <p
                    className="mb-0 me-3 fw-medium"
                    style={{
                      color:
                        appointment["Reason for Visit"] === "General Checkup"
                          ? "green"
                          : appointment["Reason for Visit"] === "Follow-up"
                          ? "#FFB800"
                          : "#1AA7FF",
                      fontSize: "12px",
                    }}
                  >
                    {appointment["Reason for Visit"]}
                  </p>
                </div>
                <div className="d-flex justify-content-between">
                  <p className="fw-bold" style={{ fontSize: "12px" }}>
                    Visit Type
                  </p>
                  <p className="mb-0 me-3" style={{ fontSize: "12px" }}>
                    {appointment["Visit Type"]}
                  </p>
                </div>

                <div className="d-flex justify-content-between mt-1">
                  <p className="fw-bold" style={{ fontSize: "12px" }}>Prescription Issued</p>
                  <span className={`badge ${appointment["Prescription Issued"] === "Yes" ? "bg-success" : "bg-danger"} me-3`} style={{ fontSize: "12px" }}>
                    {appointment["Prescription Issued"]}
                  </span>
                </div>
                <div className="d-flex justify-content-between mt-1">
                  <p className="fw-bold" style={{ fontSize: "12px" }}>Follow-Up Required</p>
                  <span className={`badge ${appointment["Follow-Up Required"] === "Yes" ? "bg-success" : "bg-danger"} me-3`} style={{ fontSize: "12px" }}>
                    {appointment["Follow-Up Required"]}
                  </span>
                </div>
              </div>

              <div className="card" style={{ borderColor: "#09940b" }}>
                <div
                  className="card-header"
                  style={{
                    borderColor: "#09940b",
                    backgroundColor: "rgba(34, 201, 37,0.3)",
                    fontWeight: 600,
                  }}
                >
                  {appointment.Doctor}
                </div>
                <div className="card-body">
                  <div>
                    <div className="d-flex flex-column gap-0 mb-1">
                      <span className="fw-bold" style={{ fontSize: "12px" }}>
                        Consultation Notes:
                      </span>
                      <p className="me-3" style={{ fontSize: "12px" }}>
                        {appointment["Consultation Notes"]}
                      </p>
                    </div>
                    
                    <div className="d-flex justify-content-between mt-2">
                      <div className="d-flex align-items-center">
                        <BsClock color="#36d413" size={16} />
                        <p
                          className="mb-0 ms-2 fw-bold"
                          style={{ fontSize: "12px" }}
                        >
                          Time Slot
                        </p>
                      </div>
                      <p className="mb-0 text-end" style={{ fontSize: "12px" }}>
                        {appointment["Time Slot"]}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AppointmentHistoryGrid;
